<template>
  <div>
    <b-container fluid>
      <b-row style="margin-bottom: 5px;">
        <b-col cols="auto">
          查詢起訖時間:
        </b-col>
        <b-col cols="10">
          <b-input-group style="width: 20vh;display: inline-flex;">
            <b-input-group-prepend is-text>
              <b-icon icon="calendar3"></b-icon>
            </b-input-group-prepend>
            <datepicker
              v-model="timepicker.minvalue"
              style="width: 13vh;"
              min="1960-01-01"
              :max="twtimeparse(timepicker.maxvalue)"
            ></datepicker>
          </b-input-group>
          <span style="display: inline-flex; margin-right: 1rem">~</span>
          <b-input-group style="width: 20vh;display: inline-flex;">
            <b-input-group-prepend is-text>
              <b-icon icon="calendar3"></b-icon>
            </b-input-group-prepend>
            <datepicker
              v-model="timepicker.maxvalue"
              style="width: 13vh;"
              :min="twtimeparse(timepicker.minvalue)"
              :max="timepicker.max"
            ></datepicker>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row
        v-show="fish.fishlist.items.length > 0"
        style="margin-bottom: 5px;"
      >
        <b-col cols="auto">
          漁市場品名:
        </b-col>
        <b-col cols="10">
          <v-select
            style="width: 25vh; display: inline-grid; margin-right: 10px;"
            v-show="fish.fishlist.items.length > 0"
            v-model="fish.fishlist.value"
            :options="fish.fishlist.options"
            :selectable="(x) => x.disabled"
          ></v-select>
          <!-- <b-spinner v-show="fish.fishlist.items.length==0" style="width: 1.5rem; height: 1.5rem;" variant="success" label="Spinning" /> -->
        </b-col>
      </b-row>
      <div v-show="fish.marketlist.options.length > 0">
        <b-row style="margin-bottom: 15px;">
          <b-col cols="auto">
            漁市場名稱:
          </b-col>
          <b-col cols="10">
            <b-form-checkbox-group
              id="checkbox-group-1"
              v-model="fish.marketlist.value"
              :options="fish.marketlist.options"
              :state="state"
            >
              <b-form-invalid-feedback :state="state"
                >請勿選超過3個市場</b-form-invalid-feedback
              >
            </b-form-checkbox-group>
          </b-col>
        </b-row>
        <!-- <b-row
          v-show="
            fish.speclist.options.length > 1 && fish.marketlist.value.length > 0
          "
          style="margin-bottom: 5px;"
        >
          <b-col cols="auto">
            漁種收成規格:
          </b-col>
          <b-col cols="10">
            <b-form-select
              style="width: 25vh; margin-bottom: 10px;"
              v-model="fish.speclist.value"
              :options="fish.speclist.options"
            ></b-form-select>
          </b-col>
        </b-row> -->
        <b-row style="margin-bottom: 5px;">
          <b-col>
            <b-form-checkbox
              id="checkbox-1"
              v-show="fish.obj.chart.options.yaxis.length > 0"
              v-model="dataLabels"
              :value="true"
              :unchecked-value="false"
              >顯示數值標籤
            </b-form-checkbox>
          </b-col>
        </b-row>
      </div>
    </b-container>
    <div style="width: 100%;">
      <apexchart
        ref="chart1ref"
        type="line"
        height="450"
        :options="fish.obj.chart.options"
        :series="fish.obj.chart.series"
      ></apexchart>
    </div>
    <div>※值為0代表無資料</div>
    <div>
      資料來源:漁業署
    </div>
  </div>
</template>

<script>
import FISHCODELIST from "@/data/FISH_CODE_LIST.json";
import datepicker from "@/components/Datepicker.vue";

export default {
  data() {
    var date = new Date();
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const maxDate = new Date(today);
    // maxDate.setDate(date.getDate() + 1);
    const minDate = new Date(today);
    minDate.setDate(date.getDate() - 30);
    var taiwanMinDate = minDate
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMinDate[0] = parseInt(taiwanMinDate[0]) - 1911;
    taiwanMinDate[1] =
      taiwanMinDate[1].length == 1 ? 0 + taiwanMinDate[1] : taiwanMinDate[1];
    taiwanMinDate[2] =
      taiwanMinDate[2].length == 1 ? 0 + taiwanMinDate[2] : taiwanMinDate[2];
    var taiwanMaxDate = maxDate
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMaxDate[0] = parseInt(taiwanMaxDate[0]) - 1911;
    taiwanMaxDate[1] =
      taiwanMaxDate[1].length == 1 ? 0 + taiwanMaxDate[1] : taiwanMaxDate[1];
    taiwanMaxDate[2] =
      taiwanMaxDate[2].length == 1 ? 0 + taiwanMaxDate[2] : taiwanMaxDate[2];
    return {
      dataLabels:true,
      fish: {
        fishlist: {
          value: { label: "請選擇", code: "請選擇", disabled: false },
          options: [],
          items: [],
        },
        items: [],
        marketlist: {
          value: [],
          options: [],
          allitems: [],
          items: [],
        },
        speclist: {
          value: null,
          options: [],
          items: [],
        },
        iffirst: true,
        ifchartshow: false,
        averageprice: false,
        maintainprice: false,
        overylayshow: true,
        selectlist: [0, "梨子", null],
        typeoptionslist: [
          { text: "請選擇種類", value: null, disabled: true },
          { text: "水果", value: 0 },
          { text: "蔬菜", value: 1 },
          { text: "雜糧特作", value: 2 },
        ],
        options: [
          { text: "請選擇作物", value: null },
          { text: "梨子", value: "梨子" },
          { text: "木瓜", value: "木瓜" },
          { text: "鳳梨", value: "鳳梨" },
        ],
        obj: {
          chart: {
            series: [],
            options: {
              chart: {
                height: 450,
                type: "line",
                zoom: {
                  enabled: false,
                },
              },
              // stroke: {
              //     width: [0, 4, 4, 4]
              //     },
              title: {
                text:  "",
              },
              dataLabels: {
                enabled: true,
              },
              stroke: { //設定線條格式[只限line & Area模式]
                curve: 'smooth', //路徑平滑
              },
              noData: {
                text: "請選擇漁市場品名",
                align: "center",
                verticalAlign: "middle",
              },
              labels: [],
              yaxis: [],
              // xaxis: {
              //   type: "datetime",
              //   labels: {
              //     formatter: function(value, timestamp) {
              //       var date = new Date(timestamp);
              //       if (date.getFullYear() < 1975) return;
              //       var year = date.getFullYear() - 1911;
              //       return (
              //         year + "/" + (date.getMonth() + 1) + "/" + date.getDate()
              //       ); // The formatter function overrides format property
              //     },
              //   },
              // },
              colors: [
                "#008FFB",
                "#19535f",
                "#FEB019",
                "#FF4560",
                "#775DD0",
                "#1c22ce",
                "#ff7b3d",
                "#f9b5c0",
                "#4c1a11",
              ],
              plotOptions: {
                bar: {
                  columnWidth: "20%",
                },
              },
            },
          },
        },
        countryoptions: {
          chart: {
            height: 350,
            type: "bar",
          },
          plotOptions: {
            bar: {
              horizontal: true,
              dataLabels: {
                position: "top",
              },
            },
          },
          title: {
            text: "108年各縣市 種植面積",
          },
          tooltip: {
            shared: true,
            intersect: false,
          },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
            categories: [
              "台中市",
              "台北市",
              "台東縣",
              "台南市",
              "宜蘭縣",
              "花蓮縣",
              "南投縣",
              "屏東縣",
              "苗栗縣",
              "桃園市",
              "高雄市",
              "雲林縣",
              "新北市",
              "新竹縣",
              "嘉義縣",
              "彰化縣",
            ],
          },
          yaxis: [
            {
              title: {
                text: "各縣市",
              },
            },
          ],
          colors: [
            "#008FFB",
            "#19535f",
            "#FEB019",
            "#FF4560",
            "#775DD0",
            "#1c22ce",
            "#ff7b3d",
          ],
        },
        charyioptions: {
          chart: {
            height: 350,
            type: "bar",
          },
          title: {
            text: "108年嘉義 鄉鎮 種植面積",
          },
          tooltip: {
            shared: true,
            intersect: false,
          },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
            categories: [
              "大林鎮",
              "中埔鄉",
              "六腳鄉",
              "太保市",
              "水上鄉",
              "布袋鎮",
              "民雄鄉",
              "朴子市",
              "竹崎鄉",
              "東石鄉",
              "大埔鄉",
              "鹿草鄉",
              "番路鄉",
              "新港鄉",
              "溪口鄉",
              "義竹鄉",
            ],
          },
          yaxis: [
            {
              title: {
                text: "種植面積(公頃)",
              },
            },
          ],
        },
      },
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#/",
        },
        {
          text: "產銷儀錶板",
          active: true,
        },
        {
          text: "漁產品交易價量分析",
          active: true,
        },
      ],
      fishcodelist: FISHCODELIST,
      timepicker: {
        minvalue: taiwanMinDate.join("-"),
        maxvalue: taiwanMaxDate.join("-"),
        // minvalue: '110-08-02',
        // maxvalue: '110-08-06',
        max: maxDate
          .toLocaleString()
          .split(" ")[0]
          .split("/")
          .join("-"),
        min: minDate
          .toLocaleString()
          .split(" ")[0]
          .split("/")
          .join("-"),
      },
      croplandlist: [],
      apiGetFishForChart: (data) =>
        this.userRequest.post("/API/Default/getFishForChart", data),
      apiGetFishFromDate: (data) =>
        this.userRequest.post("/API/Default/getFishFromDate", data),
      apiGetMarketFromFish: (data) =>
        this.userRequest.post("/API/Default/getMarketFromFish", data),
      apiGetSpecFromFish: (data) =>
        this.userRequest.post("/API/Default/getSpecFromFish ", data),
    };
  },
  mounted() {
    // this.checkLogin();
    this.init();
  },
  components: {
    datepicker,
  },
  computed: {
    state() {
      return this.fish.marketlist.value.length > 3 ? false : null;
    },
  },
  watch: {
    "fish.fishlist.value"(value) {
      let localmintime = this.timepicker.minvalue.split("-");
      localmintime[0] = parseInt(localmintime[0]) + 1911;
      let localmaxtime = this.timepicker.maxvalue.split("-");
      localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;

      let diff = Math.floor(
        (Date.parse(localmaxtime.join("-")) -
          Date.parse(localmintime.join("-"))) /
          86400000
      );

      if (value.code != "請選擇") {
        if (diff > 31) {
          alert("時間選擇區間不能超過1個月");
        } else {
          this.fish.marketlist.options = [];
          this.fish.marketlist.value = [];
          this.fish.speclist.options = [];
          this.fish.speclist.value = null;
          this.parsemarketlist();
        }
      }
    },
    "fish.speclist.value"(value) {
      if (value != null) {
        this.optionscheck();
      }
    },
    "fish.marketlist.value"(value) {
      if (value.length > 0) {
        this.optionscheck();
      } else {
        this.chartinit();
        this.fish.speclist.value = null;
      }
    },
    "timepicker.maxvalue"() {
      if (!this.iffirst)
        // this.updatechart()
        this.init();
    },
    "timepicker.minvalue"() {
      if (!this.iffirst)
        // this.updatechart()
        this.init();
    },
    "dataLabels"(val){
            if(val){
                this.$refs.chart1ref.updateOptions({
                    dataLabels:{
                        enabled:true
                    }
                })
            }
            else{
                this.$refs.chart1ref.updateOptions({
                    dataLabels:{
                        enabled:false
                    }
                })
            }
            //console.log(this.chartOptions.dataLabels)
    }
  },
  methods: {
    checkLogin() {
      let TokenID = sessionStorage.getItem("TokenID");
      if (TokenID) {
        this.checkPermission();
      } else {
        alert("無權限檢視此頁面，請登入帳號");
        this.$router.push({ path: "/login" });
      }
    },
    async checkPermission() {
      let data = { PJ_ID: "PJ000000000001", fun: this.checkByPJID };
      this.FunctionToken(this.Authority, data);
    },
    checkByPJID(value) {
      if (!value) {
        alert("無權限檢視此頁面，將返回首頁");
        this.$router.push({ path: "/" });
      } else {
        // window.addEventListener("resize", this.handleResize);
        // this.handleResize();
        this.init();
      }
    },
    getFishForChart(data) {
      this.apiGetFishForChart(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.fish.items = JSON.parse(json.Data);

            if (this.fish.items.length > 0) {
              this.fish.items.sort((a, b) => {
                let y = (a.ANA_DATE > b.ANA_DATE) - (a.ANA_DATE < b.ANA_DATE);
                return y;
              });
              this.createnewchart();
              //     this.parsefishlist()
            }
          }
        })
        .catch((err) => console.warn(err));
    },
    getFishFromDate(data) {
      this.apiGetFishFromDate(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.fish.marketlist.options = [];
            this.fish.marketlist.value = [];
            this.fish.speclist.options = [];
            this.fish.speclist.value = null;
            let arr = JSON.parse(json.Data);
            this.fish.fishlist.items = [];
            arr.forEach((x) => {
              let obj = {
                label: x.FISH,
                code: x.FISH_CODE,
                disabled: true,
              };
              this.fish.fishlist.items.push(obj);
            });
            this.fish.fishlist.options = this.fish.fishlist.items.slice(0);
            this.fish.fishlist.options.unshift({
              label: "請選擇",
              code: "請選擇",
              disabled: false,
            });
            this.fish.fishlist.value = {
              label: "請選擇",
              code: "請選擇",
              disabled: false,
            };
            this.chartinit();
            // // this.fish.fishlist.items = JSON.parse(json.Data)
            // this.createchart()
          }
        })
        .catch((err) => console.warn(err));
    },
    getMarketFromFish(data) {
      this.apiGetMarketFromFish(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.fish.marketlist.options = [];
            this.fish.marketlist.value = [];
            this.fish.speclist.options = [];
            this.fish.speclist.value = null;
            let arr = JSON.parse(json.Data);
            if (arr.length > 0) {
              arr.forEach((x) => {
                let obj = {
                  text: x.MARKET,
                  value: x.MARKET,
                };
                this.fish.marketlist.options.push(obj);
              });
            }

            let subitem = {
              text: "全國",
              value: "全國",
            };
            this.fish.marketlist.options.unshift(subitem);

            let localmintime = this.timepicker.minvalue.split("-");
            localmintime[0] = parseInt(localmintime[0]) + 1911;
            let localmaxtime = this.timepicker.maxvalue.split("-");
            localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;

            let obj = {
              start_date: localmintime.join("-"),
              end_date: localmaxtime.join("-"),
              fish_code: this.fish.fishlist.value.code,
            };
            this.FunctionToken(this.getSpecFromFish, obj);
          }
        })
        .catch((err) => console.warn(err));
    },
    getSpecFromFish(data) {
      this.apiGetSpecFromFish(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let arr = JSON.parse(json.Data);
            arr.forEach((x) => {
              let obj = {
                text: x.FISH_SPEC,
                value: x.FISH_SPEC,
              };
              this.fish.speclist.options.push(obj);
            });
            this.fish.speclist.options.unshift({
              text: "請選擇",
              value: null,
              disabled: true,
            });
            this.chartinit();
          }
        })
        .catch((err) => console.warn(err));
    },
    init() {
      let localmintime = this.timepicker.minvalue.split("-");
      localmintime[0] = parseInt(localmintime[0]) + 1911;
      let localmaxtime = this.timepicker.maxvalue.split("-");
      localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;

      // let diff = Math.floor((Date.parse(localmaxtime.join('-')) - Date.parse(localmintime.join('-'))) / 86400000);

      // if(diff>31)
      // {
      //     alert("時間選擇區間不能超過1個月")
      // }
      // else
      // {
      let obj = {
        start_date: localmintime.join("-"),
        end_date: localmaxtime.join("-"),
      };
      this.FunctionToken(this.getFishFromDate, obj);
      // }
      // this.FunctionToken(this.getTradeForChart, obj)
    },
    chartinit() {
      this.fish.obj.chart.options.yaxis = [];
      this.fish.obj.chart.series = [];
      this.fish.obj.chart.options.labels = [];
      this.dataLabels=true;
      if (this.$refs.chart1ref != undefined) {
        this.$refs.chart1ref.updateSeries(this.fish.obj.chart.series);
        this.$refs.chart1ref.updateOptions(this.fish.obj.chart.options);
      }
    },
    parsefishlist() {
      // this.fish.fishlist.options = []
      // this.fish.fishlist.items.sort((a, b) =>
      // {
      //     let y = (a.ANA_DATE > b.ANA_DATE) - (a.ANA_DATE < b.ANA_DATE)
      //     return y
      // })
      // let result1 = this.fish.fishlist.items.reduce((obj, item) => {
      //     obj[item.FISH_NAME] = 1;
      //     return obj;
      // }, {});
      // let list1 = Object.keys(result1)
      // this.fish.fishlist.options.push({ label: '請選擇', code: '請選擇', disabled: false })
      // for(let i in list1)
      // {
      //     let item1 = list1[i]
      //     this.fish.fishlist.options.push({ label: item1, code: item1, disabled: true })
      // }
    },
    parsemarketlist() {
      let localmintime = this.timepicker.minvalue.split("-");
      localmintime[0] = parseInt(localmintime[0]) + 1911;
      let localmaxtime = this.timepicker.maxvalue.split("-");
      localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;

      let obj = {
        start_date: localmintime.join("-"),
        end_date: localmaxtime.join("-"),
        fish_code: this.fish.fishlist.value.code,
      };
      // this.fish.speclist.options = list2
      this.FunctionToken(this.getMarketFromFish, obj);
    },
    optionscheck() {
      if (this.fish.marketlist.value.length > 3) {
        alert("市場選項已超過3筆，請重新選擇");
      } else {
        let localmintime = this.timepicker.minvalue.split("-");
        localmintime[0] = parseInt(localmintime[0]) + 1911;
        let localmaxtime = this.timepicker.maxvalue.split("-");
        localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;
        //this.createnewchart()
        let allindex = this.fish.marketlist.value.findIndex((x) => x == "全國");
        let obj = {};

        if (allindex != -1) {
          let optionlist = [];

          this.fish.marketlist.options.forEach((x) => {
            optionlist.push(x.value);
          });

          obj = {
            start_date: localmintime.join("-"),
            end_date: localmaxtime.join("-"),
            fish_code: this.fish.fishlist.value.code,
            MARKET: optionlist,
          };
        } else {
          obj = {
            start_date: localmintime.join("-"),
            end_date: localmaxtime.join("-"),
            fish_code: this.fish.fishlist.value.code,
            MARKET: this.fish.marketlist.value,
          };
        }
        this.FunctionToken(this.getFishForChart, obj);
      }
    },
    createnewchart() {
      this.fish.ifchartshow = true;
      this.fish.obj.chart.series = [];
      this.fish.obj.chart.options.labels = [];
      this.fish.obj.chart.options.yaxis = [];
      // let serieslist = [], datelist = []
      let mainlist = [],
        datelist = [],
        serieslist = [];

      for (let j in this.fish.items) {
        let subitem10 = this.fish.items[j];
        if (datelist.indexOf(subitem10.T_DATE) == -1) {
          datelist.push(subitem10.T_DATE);
        }
      }
      //console.log(["datelist",datelist])
      for (let i in this.fish.marketlist.value) {
        let subitem1 = this.fish.marketlist.value[i];

        if (subitem1 == "全國") {
          let list1 = [];
          //marketlength = this.fish.marketlist.options.length - 1;
          for (let i in datelist) {
            let subtime = datelist[i];
            let allavgprice = 0,
              allvolume = 0,
              count = 0;
            for (let j in this.fish.items) {
              let subitem2 = this.fish.items[j];

              if (
                subitem2.T_DATE == subtime &&
                subitem2.FISH_CODE == this.fish.fishlist.value.code
              ) {
                allavgprice = allavgprice + subitem2.PRICE_AVG;
                allvolume = allvolume + subitem2.VOLUME;
                count++;
              }
            }

            let obj1 = {
              date: subtime,
              avgprice: Math.round(allavgprice / count),
              volume: Math.round(allvolume / count),
            };
            list1.push(obj1);
          }
          let obj2 = { name: "全國", data: list1 };
          mainlist.push(obj2);
        } else {
          let list1 = [];
          for (let j in this.fish.items) {
            let subitem2 = this.fish.items[j];

            if (
              subitem2.MARKET == subitem1 &&
              subitem2.FISH_CODE == this.fish.fishlist.value.code
            ) {
              if (list1.findIndex((x) => x.date == subitem2.T_DATE) == -1) {
                let obj1 = {
                  date: subitem2.T_DATE,
                  avgprice: subitem2.PRICE_AVG,
                  volume: subitem2.VOLUME,
                };
                list1.push(obj1);
              }
            }
          }
          let obj2 = { name: subitem1, data: list1 };
          mainlist.push(obj2);
        }
      }
      let firstname = "";

      for (let k in mainlist) {
        let element1 = mainlist[k];
        let avglist = [],
          volumelist = [];

        // for(let l in element1.data)
        // {
        //     let element2 = element1.data[l]
        //     if(datelist.indexOf(element2.date)!=-1)
        //     {
        //         avglist.push(element2.avgprice)
        //         volumelist.push(element2.volume)
        //     }
        //     else
        //     {
        //         avglist.push(0)
        //         volumelist.push(0)
        //     }
        // }
        for (let t in datelist) {
          let subdate = datelist[t];
          let subindex = element1.data.findIndex((y) => y.date == subdate);
          if (subindex != -1) {
            let element2 = element1.data[subindex];
            avglist.push(element2.avgprice);
            volumelist.push(element2.volume);
          } else {
            avglist.push(0);
            volumelist.push(0);
          }
        }

        let volumeobj = {
          name: element1.name + "交易量",
          type: "column",
          data: volumelist,
        };

        serieslist.push(volumeobj);

        let avgobj = {
          name: element1.name + "拍賣均價",
          type: "line",
          data: avglist,
        };

        serieslist.push(avgobj);

        let volumeoption = {},
          avgoption = {};
        if (k == 0) {
          volumeoption = {
            seriesName: "交易量",
            title: {
              text: "交易量 ( 元 / 公斤 )",
            },
          };

          avgoption = {
            seriesName: "拍賣均價",
            opposite: true,
            title: {
              text: "價格 ( 元 / 公斤 )",
            },
          };

          firstname = element1.name + "拍賣均價";
        } else {
          volumeoption = {
            seriesName: "交易量",
            show: false,
          };

          avgoption = {
            seriesName: "拍賣均價",
            show: false,
          };
        }

        this.fish.obj.chart.options.yaxis.push(volumeoption);
        this.fish.obj.chart.options.yaxis.push(avgoption);
      }

      if (this.fish.speclist.value) {
        let averagelist2 = [],
          datelist3 = [];
        // for(let l in mainlist[0].data)
        // {
        //     let subitem = mainlist[0].data[l]
        //     averagelist2.push(subitem.fmprice)
        // }

        for (let l in datelist) {
          let dateelement = datelist[l];
          for (let n in this.fish.items) {
            let subitem5 = this.fish.items[n];
            if (
              datelist3.indexOf(subitem5.T_DATE) == -1 &&
              subitem5.T_DATE == dateelement &&
              subitem5.FISH_CODE == this.fish.fishlist.value.code
            ) {
              let avgprice2 = subitem5.FM_PRICE_L + subitem5.FM_PRICE_R;
              averagelist2.push(Math.round(avgprice2));
              datelist3.push(subitem5.T_DATE);
            }
          }
        }

        if (averagelist2.length > 0) {
          let obj = {
            name: "嘉義縣池邊價格",
            type: "line",
            data: averagelist2,
          };
          serieslist.push(obj);

          let chartoption = {
            seriesName: firstname,
            opposite: true,
            show: false,
          };
          this.fish.obj.chart.options.yaxis.push(chartoption);
        }
      }
      this.fish.obj.chart.series = serieslist;
      let arrangelist = [];
      for (let l in datelist) {
        let arrangeitem = datelist[l];
        arrangelist.push(
          parseInt(arrangeitem.substring(0, 3))+
            "/" +
            arrangeitem.substring(3, 5) +
            "/" +
            arrangeitem.substring(5, 7)
        );
      }
      //console.log("arrangelist",arrangelist)
      this.fish.obj.chart.options.labels = arrangelist;

      if(this.dataLabels) this.fish.obj.chart.options.dataLabels.enabled =true;
      else this.fish.obj.chart.options.dataLabels.enabled =false;
      // this.fish.obj.chart.series.forEach((x) => {
      //   x.data.unshift(null);
      //   x.data.push(null);
      // });

      // //往前加一天
      // let date1 = this.getnewdate(arrangelist[0], 0);
      // this.fish.obj.chart.options.labels.unshift(date1);

      // //往前減一天
      // let date2 = this.getnewdate(arrangelist[arrangelist.length - 1], 1);
      // this.fish.obj.chart.options.labels.push(date2);
      if (this.$refs.chart1ref != undefined) {
        this.$refs.chart1ref.updateSeries(this.fish.obj.chart.series);
        this.$refs.chart1ref.updateOptions(this.fish.obj.chart.options);
      }
      this.fish.ifchartshow = false;
    },
    getnewdate(date, index) {
      let firstdate = date.split("-");
      firstdate[0] = parseInt(firstdate[0]) + 1911;
      let subdate = new Date(firstdate.join("-"));
      if (index == 0) {
        subdate.setDate(subdate.getDate() - 1);
      } else {
        subdate.setDate(subdate.getDate() + 1);
      }
      let formatDate =
        parseInt(subdate.getFullYear()) -
        1911 +
        "-" +
        (subdate.getMonth() + 1) +
        "-" +
        subdate.getDate();
      return formatDate;
    },
    twtimeparse(item) {
      let tt = item.split("-");
      tt[0] = parseInt(tt[0]) + 1911;
      return tt.join("-");
    },
    changetimeformat(time) {
      let tt = time.split("-");
      tt[0] = parseInt(tt[0]) - 1911;
      return tt.join("-");
    },
    createoptions(list) {
      let list2 = [];
      for (let i in list) {
        let item1 = list[i];
        let obj = {
          label: item1.FISH_NAME + "[" + item1.FISH_SPEC + "]",
          code: item1.FISH_NAME + "&#*" + item1.FISH_SPEC,
        };
        if (list2.findIndex((x) => x.code == obj.code) == -1) list2.push(obj);
      }
      this.fish.speclist.options = list2;
    },
    createchart() {
      this.fish.fishlist.items.sort((a, b) => {
        let y = (a.ANA_DATE > b.ANA_DATE) - (a.ANA_DATE < b.ANA_DATE);
        return y;
      });

      // let result1 = this.fish.fishlist.items.reduce((obj, item) => {
      //     obj[item.FISH_NAME + ' ' + item.FISH_SPEC ] = 1;
      //     return obj;
      // }, {});

      this.createoptions(this.fish.fishlist.items);
      // this.fish.fishlist.options = Object.keys(result1)
      // this.fish.fishlist.value = this.fish.fishlist.options[0]

      let result2 = this.fish.fishlist.items.reduce((obj, item) => {
        obj[item.MARKET] = 1;
        return obj;
      }, {});

      this.fish.marketlist.options = Object.keys(result2);
      if (this.fish.marketlist.options.indexOf("嘉義") == -1) {
        this.fish.marketlist.value = this.fish.marketlist.options[0];
      }
      this.updatechart();
    },
    updatechart() {
      this.overylayshow = true;
      this.fish.obj.chart.series = [];
      this.fish.obj.chart.options.labels = [];
      this.fish.obj.chart.options.yaxis = [];
      let splitvalue = this.fish.fishlist.value.code.split("&#*");
      let list1 = [],
        list2 = [],
        list3 = [],
        serieslist = [],
        datelist = [],
        checklist = [];
      //testlist = [];
      // list4 = []
      for (let i in this.fish.fishlist.items) {
        let index2 = -1;
        let subitem1 = this.fish.fishlist.items[i];
        // if(subitem1.FISH=="吳郭魚" && subitem1.FISH_SPEC=="菜魚 500-700g/尾")
        // {
        //     if(testlist.findIndex(x=> x.FISH_SPEC == subitem1.FISH_SPEC && x.FISH==subitem1.FISH && x.FM_DATE == subitem1.FM_DATE)==-1)
        //         testlist.push(subitem1)
        // }
        if (checklist.length != 0) {
          index2 = checklist.findIndex(
            (x) =>
              x.MARKET == subitem1.MARKET &&
              x.FISH_SPEC == subitem1.FISH_SPEC &&
              x.FISH == subitem1.FISH &&
              x.FM_DATE == subitem1.FM_DATE
          );
        }

        if (
          subitem1.MARKET == this.fish.marketlist.value &&
          subitem1.FISH == splitvalue[0] &&
          subitem1.FISH_SPEC == splitvalue[1] &&
          index2 == -1
        ) {
          list1.push(subitem1.VOLUME);
          // let avgprice = (subitem1.CM_PRICE_C + subitem1.CM_PRICE_M + subitem1.CM_PRICE_F) / 3
          list2.push(subitem1.FM_PRICE);
          list3.push(subitem1.PRICE_AVG);
          // list4.push(subitem1.CM_PRICE_MON)
          subitem1.FM_DATE.substring(0, 3);
          datelist.push(
            subitem1.FM_DATE.substring(0, 3) +
              "-" +
              subitem1.FM_DATE.substring(3, 5) +
              "-" +
              subitem1.FM_DATE.substring(5, 7)
          );
          checklist.push(subitem1);
        }
      }
      let obj1 = {
        name: this.fish.marketlist.value + "交易量",
        type: "column",
        data: list1,
      };
      serieslist.push(obj1);
      let obj2 = {
        name: "嘉義縣產地價格",
        type: "line",
        data: list2,
      };
      serieslist.push(obj2);
      let obj3 = {
        name: this.fish.marketlist.value + "拍賣均價",
        type: "line",
        data: list3,
      };
      serieslist.push(obj3);
      // let obj7 = {
      //     name: '農糧署產地價格監控',
      //     type: 'line',
      //     data: list4
      // }
      // serieslist.push(obj7)
      this.fish.obj.chart.series = serieslist;
      let obj4 = {
        seriesName: this.fish.marketlist.value + "交易量",
        title: {
          text: this.fish.marketlist.value + "交易量",
        },
      };
      let obj5 = {
        seriesName: this.fish.marketlist.value + "拍賣均價",
        opposite: true,
        title: {
          text: "價格",
        },
      };
      let obj6 = {
        seriesName: this.fish.marketlist.value + "拍賣均價",
        show: false,
      };
      this.fish.obj.chart.options.labels = datelist;
      this.fish.obj.chart.options.yaxis.push(obj4);
      this.fish.obj.chart.options.yaxis.push(obj5);
      // this.fish.obj.chart.options.yaxis.push(obj6)
      this.fish.obj.chart.options.yaxis.push(obj6);
      if (this.$refs.chart1ref != undefined) {
        this.$refs.chart1ref.updateSeries(this.fish.obj.chart.series);
        this.$refs.chart1ref.updateOptions(this.fish.obj.chart.options);
      }
      this.iffirst = false;
      this.overylayshow = false;
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`)
      // let y = ymd
      const weekday = date.getDay();
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6;
    },
  },
};
</script>
